import ReactDOM from "react-dom/client"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

/* HTTP */
import axios from "axios"
import { apiOffset } from "./helpers/timezone"

/* Redux */
import { Provider } from "react-redux"
import { store } from "./store"

/* CSS */
import "./design/css/app.css"
import "./design/css/dashboard.css"
import "./design/css/auth.css"
import "./design/css/input.css"
import "./design/css/menu.css"
import "./design/css/timezone.css"
import "./design/css/header.css"
import "./design/css/chat.css"
import "./design/css/page404.css"
import "./design/css/page.css"
import "./design/css/layout.css"
import "./design/css/pagination.css"
import "./design/css/permission.css"
import "./design/css/game.css"
import "./design/css/reload.css"
import "react-datepicker/dist/react-datepicker.css"
import "./design/css/table.css"
import "./design/css/bonus.css"
import "./design/css/dealer.css"
import "./design/css/chip.css"
import "./design/css/studio.css"

import "./design/css/multipoker.css"
import "./design/css/vippoker.css"
import "./design/css/roulette.css"
import "./design/css/vipthreebox.css"

import "./design/css/rep.css"
import "./design/css/r2ep.css"
import "./design/css/sep.css"
import "./design/css/hep.css"
import "./design/css/uep.css"
import "./design/css/oep.css"
import "./design/css/qep.css"
import "./design/css/eep.css"
import "./design/css/nep.css"
import "./design/css/jep.css"
import "./design/css/eb1.css"
import "./design/css/eab.css"

import "./design/css/player.css"
import "./design/css/process.css"
import "./design/css/transaction.css"
import "./design/css/cards.css"
import "./design/css/refund.css"
import "./design/css/video.css"
import "./design/css/game-player.css"
import "./design/css/notes.css"
import "./design/css/messages.css"
import "./design/css/statistics.css"
import "./design/css/o-filter.css"


/* Attach the selected timezone offset to every request body (backend converts date ranges to UTC) */
axios.interceptors.request.use((config) => {
    if (config.data && typeof config.data === "object" && !(config.data instanceof FormData)) {
        config.data = { ...config.data, timezone: apiOffset() }
    }
    return config
})

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
    <Provider store={store}>
        <App />
    </Provider>
)

reportWebVitals()
